import React from 'react';

export const ChatContext = React.createContext({
    messages: [],
    setMessages: (value: any[] | ((prevVar: any[]) => any[])) => { },
    inputText: "",
    setInputText: (value: string) => { },
    isChatboxActive: false,
    setIsChatboxActive: (value: boolean | ((prevVar: boolean) => boolean)) => { },
    handleSendButtonClick: () => { },
    scrollToBottom: () => { },
});